import { FooterNavInfo } from "./ui/component/footernav/footernav_info";
import { FooterNavItem } from "./ui/component/footernav/footernav_item";
import { FooterNavSocialMedia } from "./ui/component/footernav/footernav_socialmedia";
import { Logo } from "./ui/component/navbar/model/logo";
import { NavItem } from "./ui/component/navbar/model/nav_item";
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import CallOutlined from '@mui/icons-material/CallOutlined';
import Mail from '@mui/icons-material/MailOutline';
import Pin from '@mui/icons-material/LocationPin';

const publicUrl = process.env.PUBLIC_URL || '';

export const logo: Logo = {
src: `${publicUrl}/logo-apami.svg`,
alt: 'APAMI - Conexão Social e Aprendizagem',
name: 'APAMI',
description: 'Convívio Social e Aprendizagem',
};

export const navItems: NavItem[] = [
{ type: 'link', href: `${publicUrl}/#/`, to: '/', text: 'Início' },
{ type: 'link', href: `${publicUrl}/#/quem-somos`, to: '/quem-somos', text: 'Quem Somos' },
{ type: 'link', href: `${publicUrl}/#/programas`, to: '/programas', text: 'Programas' },
{ type: 'link', href: `${publicUrl}/#/contrate-aprendiz`, to: '/contrate-aprendiz', text: 'Contrate um aprendiz' },
{ type: 'button', href: 'https://forms.gle/NQTrM2wJHKpHCpXZA', text: 'Inscreva-se', class: 'primary', id: 'inscreva-se' }
];

export const socialMedia: FooterNavSocialMedia[] = [
{ type: 'link', href: 'https://www.facebook.com/apamiitatibacsa/?locale=pt_BR', text: 'Facebook', icon: FacebookIcon },
{ type: 'link', href: 'https://www.instagram.com/apamiitatiba/', text: 'Instagram', icon: InstagramIcon },
{ type: 'link', href: 'https://br.linkedin.com/company/apami-conv%C3%ADvio-social-e-aprendizagem', text: 'LinkedIn', icon: LinkedInIcon },
];
export const info: FooterNavInfo[] = [
{ icon: CallOutlined, text: '(11) 4594-1355' },
{ icon: Mail, text: 'contato@apamicsa.org.br' },
{ icon: Pin, text: 'Av. Cavalheiro José Ferrari, 410, Jardim Santo Antonio, Itatiba - SP, 13251-350' },
];

export const footerNavItems: FooterNavItem[] = [
{ type: 'link', href: `${publicUrl}/#/quem-somos`, to: '/quem-somos', text: 'Quem somos' },
{ type: 'link', href: `${publicUrl}/#/programas`, to: '/programas', text: 'Programas' },
{ type: 'link', href: `${publicUrl}/#/contrate-aprendiz`, to: '/contrate-aprendiz', text: 'Contrate um Aprendiz' },
{ type: 'link', href: `${publicUrl}/#/inscreva-se`, to: '/inscreva-se', text: 'Inscreva-se' },
{ type: 'link', href: '#', text: 'Portal da Empresa' },
];
